/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback, useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { useService } from '../../../../../services/services';
import { useParams } from 'react-router-dom';
import { FormComponent } from '../../../../../components/form';

export interface IEmptyProduct {
  product_category_id: object;
  product_type_id: object;
  product_id: object;
  barns: object[];
}

const useProductList = ({
  name,
  formValues,
  field,
  emptyProduct,
}: {
  name: string;
  formValues: object;
  field: FormComponent[];
  emptyProduct: IEmptyProduct;
}) => {
  const { setValue, getValues, trigger, setError } = useFormContext();
  const [state, setState] = useState({
    count: 0,
    fields: {} as { [key: string]: FormComponent[] },
  });
  const { farmId } = useParams<{
    farmId: string;
  }>();

  const [initialized, setInitialized] = useState<boolean>(false);
  const { animalEventService } = useService();

  const addField = useCallback(
    ({ key }: { key: string; productIdx?: number; warehouseIdx?: number }) => {
      if (key === 'products') {
        setValue('products', [...getValues('products'), emptyProduct]);
      } else {
        setValue(key, [...getValues(key), emptyProduct.barns[0]]);
      }

      setState((state) => {
        state.fields[state.count.toString()] = field;

        return {
          ...state,
          count: state.count + 1,
          fields: state.fields,
        };
      });
    },
    [field]
  );

  const removeField = (rowIndex: string, key) => {
    setInitialized(true);
    const findProduct = getValues(name)[rowIndex];

    const updateProduct = () => {
      const productData = getValues('products');
      if (key !== 'products') {
        const productIdx = +key.split('.')[1];
        const data = productData.map((product, idx) => {
          if (productIdx === idx) {
            const barns = [...product.barns];
            barns.splice(barns.length - 1, 1);
            return {
              ...product,
              barns,
            };
          }
          return product;
        });

        setValue('products', data);

        getValues(key).forEach((_element, idx) => {
          setError(`${key}.${idx}.product_amount_total`, null);
          setError(`${key}.${idx}.product_unit`, null);
        });
      } else {
        const data = [...productData];

        data.splice(data.length - 1, 1);
        setValue('products', data);
      }

      trigger('products');

      setState((state) => {
        delete state.fields[rowIndex];
        state.count = Object.keys(state.fields).length;

        return { ...state };
      });
    };

    if (!!findProduct.animal_event_product_id) {
      animalEventService
        .animalEventProductDestroy(farmId, findProduct.animal_event_product_id)
        .subscribe(
          () => {
            updateProduct();
          },
          (error) => {
            console.error('Failed to remove animal:', error);
          }
        );
    } else {
      updateProduct();
    }
  };

  useEffect(() => {
    if (initialized) {
      return;
    }

    const fieldCount = getValues(name)?.length || 1;

    setState((state) => {
      if (state.count < fieldCount) {
        state.fields[state.count.toString()] = field;
        return {
          ...state,
          count: state.count + 1,
          fields: state.fields,
        };
      } else {
        return {
          ...state,
        };
      }
    });
  }, [state.count, formValues, name, addField, initialized, field]);

  return {
    state,
    addField,
    initialized,
    removeField,
  };
};

export default useProductList;
